import type { LucideIcon } from 'lucide-react-native';
import { cssInterop } from 'nativewind';

export function wrapLucideIcon(icon: LucideIcon) {
  cssInterop(icon, {
    className: {
      target: 'style',
      nativeStyleToProp: {
        color: true,
        opacity: true,
      },
    },
  });
}
